import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05d8652a")

_pushScopeId("data-v-05d8652a")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "pix"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", null, "Agora, é só pagar!", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, " Você pode pagar escaneando o QR Code acima ou pelo método Copia e Cola, apertando no botão abaixo. ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Pix Copia e Cola ")
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "O nome que aparecerá é Zoop Tecnologia.", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" O pagamento deve ser feito em até 10 minutos. Depois desse tempo, o pedido será automaticamente recusado. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Se pagou, aguarde um pouco e confira pelo botão abaixo. ")
], -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", { src: "/assets/logo.svg" }),
  /*#__PURE__*/_createVNode("h2", null, "Agora, é só aguardar!")
], -1)
const _hoisted_11 = { class: "estimated-time" }
const _hoisted_12 = { class: "phone" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, "Seu telefone", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Alterar número")
const _hoisted_15 = {
  key: 0,
  class: "cashback-info"
}
const _hoisted_16 = { class: "description" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Você ganhará ")
const _hoisted_18 = { class: "highlight" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" de cashback")
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("por esse pedido. ")
const _hoisted_22 = /*#__PURE__*/_createVNode("p", null, "Liberado em até 48 horas.", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Acompanhar Pedido")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_with_balance = _resolveComponent("header-with-balance")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            "has-go-back-modal": true,
            title: "Pedido Realizado",
            "has-go-back": false
          }),
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              (_ctx.pix)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("img", { src: _ctx.qrcode }, null, 8, ["src"]),
                    _hoisted_5,
                    _createVNode(_component_ion_button, {
                      shape: "round",
                      fill: "outline",
                      onClick: _ctx.clipboardPix
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.copySharp }, null, 8, ["icon"]),
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _hoisted_7,
                    _hoisted_8
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode("p", _hoisted_11, "Tempo estimado " + _toDisplayString(_ctx.deliveryTime) + " min", 1),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", null, [
                        _hoisted_13,
                        _createVNode("span", null, _toDisplayString(_ctx.user.phone), 1)
                      ]),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        onClick: _ctx.presentAlertChangePhoneNumber
                      }, {
                        default: _withId(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    (_ctx.cashback)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _createVNode("h3", _hoisted_16, [
                            _hoisted_17,
                            _createVNode("span", _hoisted_18, _toDisplayString(_ctx.cashback), 1),
                            _hoisted_19,
                            _hoisted_20,
                            _hoisted_21
                          ]),
                          _hoisted_22
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_button, {
                expand: "full",
                shape: "round",
                onClick: _ctx.accompanyOrder
              }, {
                default: _withId(() => [
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})